import React from 'react';
import {
    Navbar,
    Container,
    Row,
    Alert
} from 'react-bootstrap';
import {
    Info
} from 'lucide-react';

// Placeholder: the original CountryPaymentsConfig page is not present in this
// repository. The route and its sidebar entry are kept wired up so the app
// builds and navigation stays intact until the real page is restored.
export default function CountryPaymentsConfig(){
    return (
        <Container fluid>
            <Navbar>
                <Navbar.Brand>Payments Config</Navbar.Brand>
            </Navbar>
            <Row>
                <Alert variant="secondary">
                    <Info size={16} className="me-2" />
                    This page is not available yet.
                </Alert>
            </Row>
        </Container>
    );
}
